import { authHeader, config } from '../_helpers';
import Axios, { axios } from 'axios';

export const appService = {
    getAll,
    getById,
    getByName,
    update,
    getByIssueId,
    getByArticleId,
    submit,
    Post
};

function getAll(actioncontrol) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/'+ actioncontrol, requestOptions).then(handleResponse, handleError);
}

function getByName(actioncontrol) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(config.apiUrl + '/'+ actioncontrol, requestOptions).then(handleResponse, handleError);
}

function getById(actioncontrol,id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/' + actioncontrol + id, requestOptions).then(handleResponse, handleError);
}
function update(actioncontrol, appData) {

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(appData)
    };
    return fetch(config.apiUrl + '/'+ actioncontrol+'/' + appData.id, requestOptions).then(handleResponse, handleError);
    //return fetch(config.apiUrl + '/'+config.appCtrl+'/' + appData.id, requestOptions).then(handleResponse, handleError);
}


function Post(actioncontrol, data) {
    return Axios.post(config.apiUrl + '/'+ actioncontrol, data).then((result) => {})
      .catch((ex) => {
        console.error(ex);
      });
    //return fetch(config.apiUrl + '/'+config.appCtrl+'/' + appData.id, requestOptions).then(handleResponse, handleError);
}


function submit(actioncontrol, data) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(config.apiUrl + '/'+ actioncontrol, requestOptions).then(handleResponse, handleError);
    //return fetch(config.apiUrl + '/'+config.appCtrl+'/' + appData.id, requestOptions).then(handleResponse, handleError);
}

function handleResponse(response) {
    return new Promise((resolve, reject) => {
        if (response.ok) {
            // return json if it was returned in the response
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                response.json().then(json => resolve(json));
            } else {
                resolve();
            }
        } else {
            // return error message from response body
            response.text().then(text => reject(text));
        }
    });
}

function handleError(error) {
    return Promise.reject(error && error.message);
}
function getByIssueId(actioncontrol, parameters) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(parameters)
    };

    return fetch(config.apiUrl + '/' + actioncontrol , requestOptions).then(handleResponse, handleError);
}
function getByArticleId(actioncontrol, parameters) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(parameters)
    };

    return fetch(config.apiUrl + '/' + actioncontrol, requestOptions).then(handleResponse, handleError);
}


// WEBPACK FOOTER //
// ./src/_services/app.service.js